(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yl-cases-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.filtersReady === 'true') return;
      root.dataset.filtersReady = 'true';
      const batchSize = 4;
      const buttons = [...root.querySelectorAll('[data-case-filter]')];
      const cards = [...root.querySelectorAll('[data-case-card]')];
      const empty = root.querySelector('[data-case-empty]');
      const moreButton = root.querySelector('[data-case-more]');
      const filterRow = root.querySelector('.yl-cases__filters');
      let activeFilter = 'all';
      let visibleLimit = batchSize;

      const centerFilter = (button, behavior = 'smooth') => {
        if (!filterRow || !button || filterRow.scrollWidth <= filterRow.clientWidth) return;
        const rowRect = filterRow.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();
        const targetLeft = filterRow.scrollLeft
          + buttonRect.left
          - rowRect.left
          - ((rowRect.width - buttonRect.width) / 2);
        filterRow.scrollTo({ left: targetLeft, behavior });
      };

      const render = () => {
        const matchingCards = cards.filter((card) => activeFilter === 'all' || card.dataset.caseCategory === activeFilter);
        cards.forEach((card) => {
          const matchingIndex = matchingCards.indexOf(card);
          card.hidden = matchingIndex === -1 || matchingIndex >= visibleLimit;
        });
        if (empty) empty.hidden = matchingCards.length !== 0;
        if (moreButton) moreButton.hidden = matchingCards.length <= visibleLimit;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.caseFilter;
          visibleLimit = batchSize;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          render();
          centerFilter(button);
        });
      });

      if (moreButton) {
        moreButton.addEventListener('click', () => {
          visibleLimit += batchSize;
          render();
        });
      }

      render();
      centerFilter(buttons.find((button) => button.classList.contains('is-active')), 'auto');
    };
    document.querySelectorAll('[data-yl-cases]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-yl-cases]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yl-customer-stories-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.filtersReady === 'true') return;
      root.dataset.filtersReady = 'true';
      const batchSize = 4;
      const buttons = [...root.querySelectorAll('[data-case-filter]')];
      const cards = [...root.querySelectorAll('[data-case-card]')];
      const empty = root.querySelector('[data-case-empty]');
      const moreButton = root.querySelector('[data-case-more]');
      let activeFilter = 'all';
      let visibleLimit = batchSize;

      const render = () => {
        const matchingCards = cards.filter((card) => activeFilter === 'all' || card.dataset.caseCategory === activeFilter);
        cards.forEach((card) => {
          const matchingIndex = matchingCards.indexOf(card);
          card.hidden = matchingIndex === -1 || matchingIndex >= visibleLimit;
        });
        if (empty) empty.hidden = matchingCards.length !== 0;
        if (moreButton) moreButton.hidden = matchingCards.length <= visibleLimit;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.caseFilter;
          visibleLimit = batchSize;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          render();
        });
      });

      if (moreButton) {
        moreButton.addEventListener('click', () => {
          visibleLimit += batchSize;
          render();
        });
      }

      render();
    };
    document.querySelectorAll('[data-yl-cases]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-yl-cases]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yl-customer-stories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.filtersReady === 'true') return;
      root.dataset.filtersReady = 'true';
      const batchSize = 4;
      const buttons = [...root.querySelectorAll('[data-case-filter]')];
      const cards = [...root.querySelectorAll('[data-case-card]')];
      const empty = root.querySelector('[data-case-empty]');
      const moreButton = root.querySelector('[data-case-more]');
      let activeFilter = 'all';
      let visibleLimit = batchSize;

      const render = () => {
        const matchingCards = cards.filter((card) => activeFilter === 'all' || card.dataset.caseCategory === activeFilter);
        cards.forEach((card) => {
          const matchingIndex = matchingCards.indexOf(card);
          card.hidden = matchingIndex === -1 || matchingIndex >= visibleLimit;
        });
        if (empty) empty.hidden = matchingCards.length !== 0;
        if (moreButton) moreButton.hidden = matchingCards.length <= visibleLimit;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          activeFilter = button.dataset.caseFilter;
          visibleLimit = batchSize;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          render();
        });
      });

      if (moreButton) {
        moreButton.addEventListener('click', () => {
          visibleLimit += batchSize;
          render();
        });
      }

      render();
    };
    document.querySelectorAll('[data-yl-cases]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-yl-cases]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
